export * from './generate-create-account-token'
